import React from 'react';
import { Control } from 'react-hook-form/dist/types/form';
import { Typography } from '@mui/material';
import { Column, ListingForm } from 'components/shared/TableListing';
import { CurrencyInputField } from 'components/form/rhf';
import { SubsidyTableRow } from '../types';
import { ApprovedSubsidyCell } from '../ui/subsidyTable/ApprovedSubsidyCell';

export const subsidyTableHeaderColumns: Column<SubsidyTableRow>[] = [
  { header: 'DNET', renderKey: 'dnet' },
  { header: 'DNET Coefficient', renderKey: 'dnetCoefficient' },
  { header: 'Finance Amount', renderKey: 'financeAmount' },
  { header: 'Subsidy %', renderKey: 'subsidyPercent' },
  { header: 'Approved Subsidy Amount', renderKey: 'approvedSubsidyAmount' },
];

export const getSubsidyTableColumns = ({
  control,
  subsidyPercent,
  dnetCoefficient,
  disabled,
  storedApprovedSubsidyAmount,
}: {
  control: Control<ListingForm<SubsidyTableRow>>;
  subsidyPercent: number;
  dnetCoefficient: number;
  disabled?: boolean;
  storedApprovedSubsidyAmount?: number;
}): Column<SubsidyTableRow>[] => [
  {
    header: 'DNET',
    renderKey: 'dnet',
    renderCell: ({ rowIndex }) => (
      <CurrencyInputField
        label=""
        control={control as any}
        name={`bodyFields.${rowIndex}.dnet`}
        textFieldProps={{ disabled }}
      />
    ),
  },
  {
    header: 'DNET Coefficient',
    renderKey: 'dnetCoefficient',
    renderCell: () => <Typography>{dnetCoefficient}</Typography>,
  },
  {
    header: 'Finance Amount',
    renderKey: 'financeAmount',
    renderCell: ({ rowIndex }) => (
      <CurrencyInputField
        label=""
        control={control as any}
        name={`bodyFields.${rowIndex}.financeAmount`}
        textFieldProps={{ disabled }}
      />
    ),
  },
  {
    header: 'Subsidy %',
    renderKey: 'subsidyPercent',
    renderCell: () => <Typography>{subsidyPercent}%</Typography>,
  },
  {
    header: 'Approved Subsidy Amount',
    renderKey: 'approvedSubsidyAmount',
    renderCell: ({ rowIndex }) => (
      <ApprovedSubsidyCell
        rowIndex={rowIndex}
        subsidyPercent={subsidyPercent}
        dnetCoefficient={dnetCoefficient}
        storedValue={storedApprovedSubsidyAmount}
      />
    ),
  },
];
